!function (factory) {
  if (typeof module !== 'undefined') { module.exports = factory } else {
    define('app/helper/settings',[
      'app/config/constants'
    ], factory)
  }
}(function (
  CONST
) {

  var
    /**
     * @typedef {Object} StorageSetting
     * @property {function(): any} get - Gets the stored value
     * @property {function(any): void} set - Sets the stored value
     */

    /**
     * @typedef {Object} SettingsClass
     * @property {boolean} available - Whether the settings storage is available
     * @property {function(string): StorageSetting} session - Creates a session storage setting
     * @property {function(string): StorageSetting} local - Creates a local storage setting
     * @property {function(string, string): any} get - Gets a value from storage
     * @property {function(string, any, string): void} set - Sets a value in storage
     */

    /**
     * @class
     * @implements {SettingsClass}
     * @description Settings class for storing and retrieving settings using localStorage or sessionStorage
     * 
     * @example
     * // Create a setting for navbar minified state
     * var navbarMinifiedSetting = Settings.session(CONST.SETTINGS.NAVBAR_MINIFIED);
     * 
     * // Get the current state
     * if (navbarMinifiedSetting.get()) {
     *   $('body').addClass('mini-navbar');
     * }
     * 
     * // Set a new state
     * navbarMinifiedSetting.set(true);
     */
    Settings = function () {
      var
        hasLocalStorage = localStorage && typeof localStorage.getItem === 'function',
        hasSessionStorage = sessionStorage && typeof sessionStorage.getItem === 'function'

      if (!hasLocalStorage) {
        console.warn('Local storage not available', 'You will not be able to auto-save your settings beyond this session')
      }
      if (!hasSessionStorage) {
        console.warn('Session storage not available', 'You will not be able to auto-save your settings')
      }

      this.available = hasLocalStorage || hasSessionStorage

      var
        nullFn = function(){},
        nullStorage = {getItem: nullFn, setItem: nullFn, clear: nullFn, removeItem: nullFn, key: nullFn}

      function getStorage(type) {

        type = type || CONST.STORAGE_TYPE.LOCAL

        switch (type) {
          case CONST.STORAGE_TYPE.SESSION:
            return (hasSessionStorage && sessionStorage)
              || nullStorage
            break
          case CONST.STORAGE_TYPE.LOCAL:
            return (hasLocalStorage && localStorage)
              || (hasSessionStorage && sessionStorage)
              || nullStorage
            break
          default:
            throw new Error('Unsupported storage type requested; ' + type)
            break
        }
      }

      function get(key, type) {
        var cvalstr = getStorage(type).getItem(key),
          dataStr,
          data
        try {
          if (cvalstr) {
            dataStr = atob(cvalstr).trim()
          }
          if (dataStr && dataStr.match(/^\{.*\}$/)) {
            data = JSON.parse(atob(cvalstr))
          }
        } catch (err) {
          console.warn('could not retrieve value due to decoding issues; resetting storage key;', key, type, err)
          set(key, null, type)
        }
        return data ? data.val : null
      }

      function set(key, val, type) {
        var cval = { val: val },
          strval = btoa(JSON.stringify(cval))
        if (strval.length > 1024 * 128 * 8) {
          console.warn('Warning! Dont save too big values into storage. Saving ' + Math.ceil(strval.length / 8 / 1024) + 'kB.')
        }
        getStorage(type).setItem(key, strval)
      }

      function setting(key, type) {
        return {
          get: function () { return get(key, type) },
          set: function (val) { return set(key, val, type) }
        }
      }

      this.get = get
      this.set = set

      this.session = function (key) {
        return setting(key, CONST.STORAGE_TYPE.SESSION)
      }
      this.local = function (key) {
        return setting(key, CONST.STORAGE_TYPE.LOCAL)
      }
    }

  return new Settings()

});
